import { axios } from '../../../config/connection/axios';

import { AuthUser } from '../types';

export const getUser = (): Promise<AuthUser> => {
  return axios.get('/auth/me'); // Check whether user is logged by verifing if a token is set. TODO: change later as user can set it manually and access dashboard while not being authenticated.
};